module.exports = __webpack_public_path__ + "img/new_change(1).88c9f466.jpg";